import { ReactNode } from "react";
import cx from "classnames";

type Props = {
  children: ReactNode | string;
  className?: string;
  width?: string;
};

const HrScroll = ({ children, width, className }: Props) => {
  return (
    <div
      className={cx("no-scrollbar flex items-stretch overflow-x-scroll", className)}
      style={{ width }}
    >
      {children}
    </div>
  );
};

export default HrScroll;
